import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import App from './App';
import { TimeLynxxThemeProvider, useTimeLynxxTheme } from './contexts/ThemeContext';
import { createTimeLynxxTheme } from './theme/theme';

// TODO: Configure Amplify with actual backend config
// Amplify.configure(amplifyconfig);

const ThemedApp = () => {
  const { mode } = useTimeLynxxTheme();
  const theme = createTimeLynxxTheme(mode);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  );
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <TimeLynxxThemeProvider>
        <ThemedApp />
      </TimeLynxxThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);